import { render, staticRenderFns } from "./DormUserDormUpdate.vue?vue&type=template&id=6ddd39b0&"
import script from "./DormUserDormUpdate.vue?vue&type=script&lang=js&"
export * from "./DormUserDormUpdate.vue?vue&type=script&lang=js&"
import style0 from "./DormUserDormUpdate.vue?vue&type=style&index=0&id=6ddd39b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports